import Img from "../../common/Img";

export default function EventError(props) {
    const data = props.data;

    return (
        <div className="c_17">
            <div className="c_17_1">
                <div className="c_18" data-live>
                    <div className="c_18_1">
                        <span className="c_18_1_2">{data.sportDesc} | {data.categoryDesc} | {data.tournamentDesc}</span>
                        <div className="c_18_1_4"></div>
                        <div className="c_18_1_3">
                            <Img className="c_18_1_3_1" src="icon_pin_default.svg" height="32px" width="32px" />
                            <Img className="c_18_1_3_1" src="icon_close.svg" height="32px" width="32px" onClick={props.close} />
                        </div>
                    </div>
                    <div className="c_18_2">
                        <div className="c_18_2_1">
                            <div className="c_18_2_1_1">{data.dateShort}</div>
                            <div className="c_18_2_1_2">{data.team1}</div>
                            <div className="c_18_2_1_3"></div>
                            <div className="c_18_2_1_4"></div>
                        </div>
                        <div className="c_18_2_1">
                            <div className="c_18_2_1_1">{data.time}</div>
                            <div className="c_18_2_1_2">{data.team2}</div>
                            <div className="c_18_2_1_3"></div>
                            <div className="c_18_2_1_4"></div>
                        </div>
                    </div>
                </div>
            </div>
            {props.children}
        </div>
    );
}
